import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "pager" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "new-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Collection = _resolveComponent("Collection")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_Check = _resolveComponent("Check")
  const _component_el_button = _resolveComponent("el-button")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.REFERENCE,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['REFN_SELECT'] && !_ctx.loading]
        ]),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.activeName) = $event)),
                  accordion: "",
                  ref: "coll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse_item, { name: "1" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_icon, { size: 32 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Collection)
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title-label" }, "Referenzen", -1))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.filter,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filter) = $event)),
                            placeholder: "Filter",
                            onInput: _ctx.onFilterChange,
                            clearable: ""
                          }, null, 8, ["modelValue", "onInput"]),
                          _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.displayList }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "referenceid",
                                label: "ID",
                                width: "80"
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "title",
                                label: "Titel"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.displayList[scope.$index].title,
                                    "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].title) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "author",
                                label: "Autor",
                                width: "120"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.displayList[scope.$index].author,
                                    "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].author) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "issue",
                                label: "Auflage",
                                width: "130"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.displayList[scope.$index].issue,
                                    "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].issue) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "isbn",
                                label: "ISBN/DOI",
                                width: "150"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.displayList[scope.$index].isbn,
                                    "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].isbn) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "isbn",
                                label: "Erscheinungsdatum",
                                width: "250"
                              }, {
                                default: _withCtx((scope) => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.displayList[scope.$index].displaydate,
                                    "onUpdate:modelValue": $event => ((_ctx.displayList[scope.$index].displaydate) = $event),
                                    type: "date",
                                    placeholder: "Bitte wählen...",
                                    format: "DD.MM.YYYY"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "dateupdate",
                                label: "Letzte Änderung",
                                width: "150"
                              }, {
                                default: _withCtx((scope) => [
                                  _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.displayList[scope.$index].dateupdate))), 1)
                                ]),
                                _: 1
                              }),
                              (_ctx.hasPermission['REFN_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "success",
                                        onClick: $event => (_ctx.onReferenceSaveClick(_ctx.displayList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.hasPermission['REFN_DELETE'])
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 1,
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "danger",
                                        onClick: $event => (_ctx.onReferenceDeleteClick(_ctx.displayList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["data"])), [
                            [_directive_loading, _ctx.loading]
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_el_pagination, {
                              background: "",
                              layout: "prev, pager, next",
                              total: _ctx.filteredList.length,
                              pageSize: _ctx.rowsPerPage,
                              currentPage: _ctx.page,
                              onCurrentChange: _ctx.onPageChange
                            }, null, 8, ["total", "pageSize", "currentPage", "onCurrentChange"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.hasPermission['REFN_INSERT'])
                      ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: 0,
                          name: "2"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-label" }, "Neue Referenz", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_el_form, {
                                  ref: "newReferenceForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.newReferenceModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Titel",
                                      prop: "title"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newReferenceModel.title,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.newReferenceModel.title) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Autor",
                                      prop: "author"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newReferenceModel.author,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.newReferenceModel.author) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Auflage",
                                      prop: "issue"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newReferenceModel.issue,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.newReferenceModel.issue) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "ISBN/DOI",
                                      prop: "isbn"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newReferenceModel.isbn,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.newReferenceModel.isbn) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Erscheinungsdatum",
                                      prop: "releasedate"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.newReferenceModel.releasedate,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.newReferenceModel.releasedate) = $event)),
                                          type: "date",
                                          placeholder: "Bitte wählen...",
                                          format: "DD.MM.YYYY",
                                          onChange: _ctx.onInput
                                        }, null, 8, ["modelValue", "onChange"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formValid,
                                          onClick: _ctx.onNewReferenceClick
                                        }, {
                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("Hinzufügen ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['REFN_SELECT']]
        ])
      ])
    ])
  ], 64))
}